import React from 'react'
import Spinner from 'app/components/Spinner/Spinner'
import { withTranslation } from 'react-i18next'

const GalleryLoader = ({ t }) => (
  <div style={{ height: '252px' }}>
    <Spinner title={t('Loading Gallery')} transparent />
  </div>
)

GalleryLoader.displayName = 'GalleryLoader'

export default withTranslation()(GalleryLoader)
